import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from 'school-space-client/components';

import RiskAssessment from 'dashboard/components/documents/riskassessment';
import SafeguardingPolicy from 'dashboard/components/documents/safegurdingpolicy';
import PublicLiabilityInsurance from 'dashboard/components/documents/liabilityinsurance';
import PaymentSetup from 'dashboard/components/documents/paymentSetup';

import { getSupportingDocuments } from 'school-space-client/api';
import constants from '../../constanst';

const TABS = {
    RISK: 'risk-assessment',
    SAFEGUARDING: 'safegurding-policy',
    LIABILITY: 'liability-insurance',
    PAYMENT: 'payment'
};

export default function SupportingInforation() {
    const user = useContext(UserContext);
    console.log('🚀 ~ SupportingInforation ~ user:', user);
    const { id } = user;

    const [activeTab, setActiveTab] = useState(TABS.RISK);
    const [documents, setDocuments] = useState({
        riskAssessment: {
            id: '',
            customerId: '',
            name: '',
            documentType: constants.documentTypeConst.riskAssessment,
            approvalStatus: false,
            expiryDate: '',
            documentUrl: ''
        },
        safeGaurdingPolicy: {
            id: '',
            customerId: '',
            name: '',
            documentType: constants.documentTypeConst.safeGaurdingPolicy,
            approvalStatus: false,
            expiryDate: '',
            documentUrl: ''
        },
        liabilityInsurance: {
            id: '',
            customerId: '',
            name: '',
            documentType: constants.documentTypeConst.liabilityInsurance,
            approvalStatus: false,
            expiryDate: '',
            documentUrl: ''
        }
    });

    // Load correct tab from URL hash on mount
    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (Object.values(TABS).includes(hash)) {
            setActiveTab(hash);
        }

        const handleHashChange = () => {
            const newHash = window.location.hash.replace('#', '');
            if (Object.values(TABS).includes(newHash)) {
                setActiveTab(newHash);
            }
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    // Update hash when active tab changes
    useEffect(() => {
        if (window.location.hash !== `#${activeTab}`) {
            window.history.replaceState(null, '', `#${activeTab}`);
        }
    }, [activeTab]);

    // Load documents
    useEffect(() => {
        getSupportingDocuments(id)
            .then(docs => {
                const updatedDocuments = { ...documents };

                docs.forEach(doc => {
                    if (doc.documentType === constants.documentTypeConst.riskAssessment) {
                        updatedDocuments.riskAssessment = doc;
                    }
                    if (doc.documentType === constants.documentTypeConst.safeGaurdingPolicy) {
                        updatedDocuments.safeGaurdingPolicy = doc;
                    }
                    if (doc.documentType === constants.documentTypeConst.liabilityInsurance) {
                        updatedDocuments.liabilityInsurance = doc;
                    }
                });

                setDocuments(updatedDocuments);
            })
            .catch(console.warn);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const renderTabClass = tab => `nav-link ${activeTab === tab ? 'active' : ''}`;
    const renderPaneClass = tab => `tab-pane fade ${activeTab === tab ? 'show active' : ''}`;

    return (
        <div className="customerTab">
            <ul className="nav" role="tablist">
                <li className="nav-item">
                    <a
                        className={renderTabClass(TABS.RISK)}
                        onClick={() => setActiveTab(TABS.RISK)}
                    >
                        {documents.riskAssessment.approvalStatus && (
                            <img src="images/tick-back.png" alt="tick" />
                        )}
                        Risk Assessment
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={renderTabClass(TABS.SAFEGUARDING)}
                        onClick={() => setActiveTab(TABS.SAFEGUARDING)}
                    >
                        {documents.safeGaurdingPolicy.approvalStatus && (
                            <img src="images/tick-back.png" alt="tick" />
                        )}
                        Safeguarding Policy
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={renderTabClass(TABS.LIABILITY)}
                        onClick={() => setActiveTab(TABS.LIABILITY)}
                    >
                        {documents.liabilityInsurance.approvalStatus && (
                            <img src="images/tick-back.png" alt="tick" />
                        )}
                        Proof of Public Liability Insurance
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={renderTabClass(TABS.PAYMENT)}
                        onClick={() => setActiveTab(TABS.PAYMENT)}
                    >
                        {user.customerDeposits !== null && (
                            <img src="images/tick-back.png" alt="tick" />
                        )}
                        Payment Method
                    </a>
                </li>
            </ul>

            <div className="tab-content">
                <div id={TABS.RISK} className={renderPaneClass(TABS.RISK)}>
                    <RiskAssessment
                        documents={documents}
                        setGlobalDocuments={setDocuments}
                        documentTypeConst={constants.documentTypeConst}
                    />
                </div>
                <div id={TABS.SAFEGUARDING} className={renderPaneClass(TABS.SAFEGUARDING)}>
                    <SafeguardingPolicy
                        documents={documents}
                        setGlobalDocuments={setDocuments}
                        documentTypeConst={constants.documentTypeConst}
                    />
                </div>
                <div id={TABS.LIABILITY} className={renderPaneClass(TABS.LIABILITY)}>
                    <PublicLiabilityInsurance
                        documents={documents}
                        setGlobalDocuments={setDocuments}
                        documentTypeConst={constants.documentTypeConst}
                    />
                </div>
                <div id={TABS.PAYMENT} className={renderPaneClass(TABS.PAYMENT)}>
                    <PaymentSetup
                        documents={documents}
                        setGlobalDocuments={setDocuments}
                        documentTypeConst={constants.documentTypeConst}
                    />
                </div>
            </div>
        </div>
    );
}
